module.exports = __webpack_public_path__ + "media/images/covers/sw-thumb-02-9e45672fc26e816a698242c5d0933cd6.jpg";